// "X or more" tiers, single-select, shared by SeatingCapacityFilterDropdown
// and FiltersDialog. The backend's seats filter only supports an
// exact-match list (seats[]=4&seats[]=5&...), not a >= threshold, so each
// tier expands to every seat count from its threshold up to this cap - well
// above anything in a car-rental fleet - to approximate "or more".
export const SEAT_THRESHOLDS = [4, 5, 6, 7];
const MAX_SEATS_CAP = 12;

export const seatsForThreshold = (threshold) => {
  const seats = [];
  for (let seat = threshold; seat <= MAX_SEATS_CAP; seat++) seats.push(seat);
  return seats;
};

/*******************
@purpose : true when the currently selected seats list is exactly the
           expanded "X or more" list for a given threshold
@Parameter : {threshold, selectedSeats}
@Author : INIC
******************/
export const thresholdMatches = (threshold, selectedSeats) => {
  const expected = seatsForThreshold(threshold);
  if (!selectedSeats || selectedSeats.length !== expected.length) return false;
  const sorted = [...selectedSeats].sort((a, b) => a - b);
  return expected.every((seat, i) => seat === sorted[i]);
};
